export const TYPE = {
    SINGLE: 1,
    COUPLE: 2
}
export const TABS = [
    {
        key: TYPE.SINGLE,
        name: "单职工申请"
    },
    {
        key: TYPE.COUPLE,
        name: "夫妻共同申请"
    },
]

export const isValidDate = (start, end, is_equal = false) => {
    if (is_equal) {
        return new Date(start).getTime() <= new Date(end).getTime()
    }
    return new Date(start).getTime() < new Date(end).getTime()
}

export const tips = [
    '1.符合住房公积金个人住房贷款条件的两人及以上职工单笔最高贷款额度为70万元，单职工单笔最高贷款额度为40万元。',
    '2.贷款期限应以整年计算，最短为1 年，最长为30 年，且贷款到期日不超过借款申请人法定退休时间后5 年。',
    '3.符合贷款条件的两人及以上借款申请人，可按期限较长的一方确定贷款期限。',
    `4.贷款额度计算公式为：
    可贷额度=∑（缴存职工每个月的缴存净额×该月对应的月份数i×贷款基础系数）。
    （1）缴存职工每个月的缴存净额，是指该月实际缴存入账的金额减去该月应被抵扣的金额。
    （2）i表示月份数。公积金最近一次缴存入账的月份为i=1，自i=1开始依序往前倒推自然月。
    （3）贷款基础系数为0.9，由成都公积金中心根据流动性状况等因素适时调整贷款基础系数并公布。`,
]